module.exports = __webpack_public_path__ + "img/close-icon-dark.50fdccab.svg";